














export default {
    name: 'MarketIcon',
    props: {
        size: {
            type: String,
            default: '',
            required: false,
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/terminal/app/modules/eventGrid/components/MarketIcon.vue